import { render, staticRenderFns } from "./TagSelect.vue?vue&type=template&id=843ef842"
import script from "./TagSelect.vue?vue&type=script&lang=js"
export * from "./TagSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports